// Analítica de visitas vía Umami (self-hosted, sin cookies).
//
// Se inyecta solo si hay configuración (VITE_UMAMI_SRC + VITE_UMAMI_WEBSITE_ID),
// que llegan como build args en producción. En desarrollo están vacíos → no se
// carga nada. Se llama desde main.tsx (cliente), nunca en el prerender (Node).

/** Inyecta el script de Umami una sola vez si está configurado. */
export function initAnalytics(): void {
  if (typeof document === 'undefined') return; // seguro en prerender/tests sin DOM
  const src = import.meta.env.VITE_UMAMI_SRC;
  const websiteId = import.meta.env.VITE_UMAMI_WEBSITE_ID;
  if (!src || !websiteId) return;
  if (document.querySelector('script[data-umami]')) return; // ya inyectado
  const s = document.createElement('script');
  s.defer = true;
  s.src = src;
  s.setAttribute('data-website-id', websiteId);
  s.setAttribute('data-umami', 'true');
  document.head.appendChild(s);
}

/**
 * Registra un evento personalizado. Lo usamos en los CTAs que llevan a la app
 * ('cta-app-click') para medir el embudo landing → app. No-op si Umami no está
 * cargado.
 */
export function trackEvent(name: string, data?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return;
  window.umami?.track(name, data);
}
